/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Ensure you have a div with id 'root' in your index.html
const container = document.getElementById('root');

if (container) {
  const root = createRoot(container); // Create a root.
  root.render(<App />); // Initial render
} else {
  console.error("Could not find root element to mount to!");
}
